<template>
	<slot :items="products" />
</template>

<script setup>
	const catalog = useCatalog();
	const emit = defineEmits(['loadProductsWidget']);
	const props = defineProps({
		fetch: Object,
		items: Array,
		mode: String,
	});
	const config = useAppConfig();
	const products = shallowRef([]);
	const info = useInfo();
	const frosmoStrategies = info.getInfo('frosmo_strategies');
	const frosmoArray = frosmoStrategies.split('\n');
	let frosmoRecCode = shallowRef(null);
	let frosmoStrategy = shallowRef(null);

	let checkInterval = null;
	function frosmoInit(recommendation_code, strategy, max_products) {
		// wait for frosmo to be loaded
		checkInterval = setInterval(() => {
			if (window.frosmo) {
				if(checkInterval) clearInterval(checkInterval);
				frosmoLoadStrategy(recommendation_code, strategy, max_products);
			}
		}, 300);

		setTimeout(() => {
			if(checkInterval) clearInterval(checkInterval);
		}, 10000);
	}

	//frosmo function
	async function frosmoLoadStrategy(recommendation_code, strategy, max_products) {
		//console.debug('frosmo.easy.strategies, recommendation_code:', recommendation_code, ' strategy:', strategy);

		if (window.frosmo?.easy && window.frosmo?.easy?.strategies && strategy) {
			window.frosmo.easy.strategies.fetch(strategy).then(async function (response) {
				if(response?.data?.length) {
					const productsID = response.data?.map(product => product.id);
					const frosmoProducts = await catalog.fetchProducts({
							mode: 'widget',
							code_exact_sort: 1,
							limit: productsID.length,
							code: productsID,
							response_fields: config.catalog.productsResponseFields
						});

					if(frosmoProducts?.data?.items?.length) {
						products.value = frosmoProducts.data.items;
					}
				}
			})
			.catch(function (error) {
				console.error(error);
			});
		}
	}

	// emit event with initial list
	onMounted(async () => {
		//frosmo
		if(frosmoArray.length && props.mode) {
			const foundValue = frosmoArray.find(item => item.startsWith(props.mode));
			if (foundValue) {
				const splitValue = foundValue.split('=');
				frosmoRecCode.value = (splitValue.length >= 2) ? splitValue[0] : null;
				frosmoStrategy.value = (splitValue.length >= 2) ? splitValue[1] : null;
			}

			if(frosmoStrategy.value) {
				frosmoInit(frosmoRecCode.value, frosmoStrategy.value, 5);
			} else {
				// if items are provided, use them and ignore fetch prop. Otherwise fetch items from API
				if (props.items) {
					products.value = props.items;
				} else {
					const productData = await catalog.fetchProducts({
						response_fields: config.catalog.productsResponseFields,
						...props.fetch,
					});
					if(productData?.data?.items) {
						products.value = productData.data.items;
					}
				}
			}
		} else {
			if (props.items) {
				products.value = props.items;
			} else {
				const productData = await catalog.fetchProducts({
					response_fields: config.catalog.productsResponseFields,
					...props.fetch,
				});
				if(productData?.data?.items) {
					products.value = productData.data.items;
				}
			}
		}

		emit('loadProductsWidget', {items: products.value, data: props.items ? props.items : props.fetch});
	});
</script>
